import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';

import { Container, Wrapper } from 'components/Layout/Layout';
import { RectangleButton } from 'components/Button/RectangleButton';
import { useActions } from 'hooks/useActions';
import * as actions from './actions';
import * as AuthActions from 'global/actions/authActions';
import Path from 'routes/Path';
import { Spinner } from 'components/Spinner/Spinner';
import { PlansContainer, PlansWrapper, TransactionHeading, LabelHeading } from './styles';

export default function StripeResponsePage() {
  const { paymentID, transactionId, paymentStatus } = useParams();
  const navigate = useNavigate();

  const [isTransactionSuccessful, setIsTransactionSuccessful] = useState(false);
  const [isDemoConverted, setIsDemoConverted] = useState(false);
  const [isSubscriptionPlan, setIsSubscriptionPlan] = useState(false);

  const { loading, successResponse, failedResponse, error } = useSelector((state) => state.PlansPageReducer);

  const { updateSuccessfulTransaction, updateFailedTransaction } = useActions(actions);
  const { verifyAuthState } = useActions(AuthActions);

  useEffect(() => {
    if (paymentStatus === 'true') updateSuccessfulTransaction(paymentID, transactionId);
    else updateFailedTransaction(paymentID);
  }, [paymentID, transactionId, paymentStatus, updateSuccessfulTransaction, updateFailedTransaction]);

  useEffect(() => {
    if (successResponse) {
      setIsTransactionSuccessful(true);
      setIsDemoConverted(successResponse.isDemoConverted);
      setIsSubscriptionPlan(successResponse.isSubscriptionPlan);
      verifyAuthState();
    }
  }, [successResponse, verifyAuthState]);

  useEffect(() => {
    if (failedResponse) {
      setIsTransactionSuccessful(false);
    }
  }, [failedResponse]);

  useEffect(() => {
    if (error.includes('Payment already updated')) {
      toast.error(error);
      navigate(Path.payments);
    }
  }, [error, navigate]);

  return (
    <Wrapper minHeight="100vh">
      <Container usePadding="0" column full>
        <PlansContainer>
          <PlansWrapper alignLeft>
            {loading && (
              <Spinner
                title="Please wait while your payment is processing"
                text="Do not refresh / reload the page until processing is done..."
              />
            )}
            {!loading && (
              <>
                <TransactionHeading>
                  {isTransactionSuccessful ? 'Transaction Successful' : 'Transaction Failed'}
                </TransactionHeading>
                <LabelHeading>
                  {isTransactionSuccessful
                    ? isSubscriptionPlan
                      ? 'Thank you for subscribing to the freecode+ monthly payment plan. You now have access to freecode+ tests.'
                      : isDemoConverted
                        ? 'Thank you for purchasing tests - Your account has been activated'
                        : 'Thank you for purchasing tests - the test credits have been added to your account.'
                    : 'Please try again'}
                </LabelHeading>
                <RectangleButton
                  floatRight
                  onClick={() => navigate(isTransactionSuccessful ? Path.payments : Path.subscriptionPlans)}
                >
                  OK
                </RectangleButton>
              </>
            )}
          </PlansWrapper>
        </PlansContainer>
      </Container>
    </Wrapper>
  );
}
